import isEmpty from 'lodash-es/isEmpty'
import map from 'lodash-es/map'
import React from 'react'
import { Link } from 'react-router-dom'

import { AspectBox } from '@fourthwall/components'
import { reverse, routing } from '@utils/routing'

import { PhotoThumbnail } from '../../PhotoThumbnail'
import { VirtualProductThumbnail } from '../../VirtualProductThumbnail'
import type { ProductsListItemProps } from '../types'
import * as S from './styled'

export const ProductsListItem = ({
  image,
  name,
  offerId,
  quantity,
  price,
  variants,
  details,
  size,
  tag,
  donation,
  type = 'product',
}: ProductsListItemProps) => {
  const renderImage = () => {
    if (donation) {
      return <VirtualProductThumbnail size={size} />
    }

    return <PhotoThumbnail url={image} type={type} size="large" />
  }

  const renderVariants = () => {
    if (isEmpty(variants)) return null

    if (typeof variants === 'string') {
      return <S.Details>{variants}</S.Details>
    }

    let variantsArray

    if (size === 'small') {
      variantsArray = map(variants, ({ value }) => value && value)
    } else {
      variantsArray = map(variants, ({ prefix, value }) => value && `${prefix}: ${value}`)
    }

    return <S.Details>{variantsArray.filter(Boolean).join(', ')}</S.Details>
  }

  const renderName = () => {
    if (!offerId) {
      return name
    }

    return (
      <S.NameLink as={Link} to={reverse(routing.products.all.product.self, { productId: offerId })}>
        {name}
      </S.NameLink>
    )
  }

  return (
    <S.ItemContainer size={size}>
      <S.ImageContainer>
        <AspectBox ratio="3:4">{renderImage()}</AspectBox>
      </S.ImageContainer>
      <S.Name>
        {renderName()}
        {renderVariants()}
        {details && <S.Details>{details}</S.Details>}
      </S.Name>
      <S.Quantity>{quantity}</S.Quantity>
      <S.Price>{price}</S.Price>
      {tag && (
        <S.Tag>
          <S.TagWrapper>{tag}</S.TagWrapper>
        </S.Tag>
      )}
    </S.ItemContainer>
  )
}
